export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/dof-popup/index.js